import { AssetsService } from '@coosmo/shared-utils'

const prevPageIcon = AssetsService.getSvgIcon('prevStep.svg')
const nextPageIcon = AssetsService.getSvgIcon('nextStep.svg')

function navigationButtons(nextFunction, prevFunction) {
  const navigationContainer = document.getElementById('nexus-controls')
  const div = document.createElement('div')
  div.className = 'buttonsContainer'
  div.id = 'navigationButtons'
  const buttonsArrow = `
  <div id="prevPage"
  class="button pageButton pageButtonPrev iconSvg ">
<img src ="${prevPageIcon}">
</div>
<div id="nextPage"
  class="button pageButton pageButtonNext iconSvg ">
<img src ="${nextPageIcon}">
</div>`
  div.innerHTML = buttonsArrow

  navigationContainer.prepend(div)
  // widgetContainer.insertAdjacentHTML('afterend', toolbarDom)

  const nextModel = document.getElementById('nextPage')
  const prevModel = document.getElementById('prevPage')

  nextModel.addEventListener('click', () => {
    nextFunction()
  })

  prevModel.addEventListener('click', () => {
    prevFunction()
  })

  navigationContainer.addEventListener('mousedown', event => {
    event.stopPropagation()
  })
}
export default { navigationButtons }
